import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ChatBubbleLeftRightIcon,
  Cog6ToothIcon,
} from '@heroicons/react/24/outline';
import { useAuth } from '../../contexts/AuthContext';
import WhatsAppInbox from './WhatsAppInbox';
import WhatsAppConfig from './WhatsAppConfig';

// ---------------------------------------------------------------------------
// WhatsApp page shell: 2 tabs — Conversaciones (inbox) | Configuración (config).
//
// Configuración is admin/super_admin only (matches the old Settings.js gate);
// callers/managers only see Conversaciones. Defensive: if a non-admin somehow
// lands on the config tab, we fall back to the inbox render rather than
// exposing the config surface.
// ---------------------------------------------------------------------------

function WhatsAppPage() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';

  const [tab, setTab] = useState('inbox');
  const activeTab = tab === 'config' && isAdmin ? 'config' : 'inbox';

  const tabBtn = (key, label, Icon) => {
    const active = activeTab === key;
    return (
      <button
        type="button"
        onClick={() => setTab(key)}
        className={`inline-flex items-center gap-1.5 border-b-2 px-3 py-2 text-sm font-medium transition-colors ${
          active
            ? 'border-emerald-500 text-emerald-600 dark:text-emerald-400'
            : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
        }`}
      >
        <Icon className="h-4 w-4" />
        {label}
      </button>
    );
  };

  return (
    <div className="flex h-[calc(100vh-6.5rem)] flex-col">
      <div className="flex flex-none items-center gap-1 border-b border-gray-200 dark:border-gray-700">
        {tabBtn('inbox', t('whatsapp.tabs.conversations'), ChatBubbleLeftRightIcon)}
        {isAdmin &&
          tabBtn('config', t('whatsapp.tabs.config'), Cog6ToothIcon)}
      </div>

      <div className="min-h-0 flex-1 pt-4">
        {activeTab === 'config' ? <WhatsAppConfig /> : <WhatsAppInbox />}
      </div>
    </div>
  );
}

export default WhatsAppPage;
